export default "__VITE_ASSET__BiCKCDqA__"